module.exports = __webpack_public_path__ + "img/content-1.1d1dfe05.png";